import React, {useState} from "react";
import Menu from './menu/menu.jsx';
import MapCoverage from "./mapCoverage.jsx";
import { useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from "react-bootstrap/Card";
import Footer from './menu/footer.jsx';
import Button from 'react-bootstrap/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { I18nPropvider } from './../i18nProvider';
import { useNavigate } from "react-router-dom";

export function DetailSatellite() {

    const history = useNavigate();
    const location = useLocation().state;
    const [locale, setLocale] = useState(location.locale);

    return (
        <I18nPropvider locale={location.locale}>
            <div className="App overflow-auto" >
                <header className="App-header">
                    <div>
                        <Menu locale={location.locale} onChangeValue={(data) => { setLocale(data) }}></Menu>
                    </div>
                </header>
                <br />

                <Container className="channelDetailContainer">
                    <Card bg="white">
                        <Row>
                            <Col>
                                <Button type="button" aria-label="Back" title="Back" className="backButton" onClick={() => history(-1)}>{<ArrowBackIcon />}</Button>
                            </Col>
                        </Row>
                        <Card.Body>
                            <div id="map" style={{ height: "500px", width: "100%" }}>
                                {location.mapPolygons && (
                                    <MapCoverage satellite={location.satellite} mapPolygons={location.mapPolygons} powerLevelWithCoord={location.powerLevelWithCoord} beam={location.beam}></MapCoverage>
                                )}
                            </div>
                        </Card.Body>
                    </Card>
                </Container>

                <div className="clear"></div>

                <footer className="footer">
                    <Footer></Footer>
                </footer>
            </div>
        </I18nPropvider>
    );
}
export default DetailSatellite;
